import { createSlice } from "@reduxjs/toolkit";

const initialDashboardState = {
  actionsLoading: true,
  listLoading: false,
  notificationEntities: [],
  jobEntities: [],
  statsDateRange:{},
  totalNotificationCount: null,
  message: {
    error: null,
    success: null,
  },
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: initialDashboardState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
      if (error.constructor.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // dashboardStats fetched from api
    dashboardStatsFetched: (state, action) => {
      // console.log("🚀 ~ file: dashboardSlice.js ~ line 44 ~ action.payload", action.payload);
      //   state.listLoading = false;
      //   state.error = null;
    },

    notificationsFetched: (state, action) => {
      const { totalCount } = action.payload;
      state.notificationEntities = action.payload.entities;
      state.totalNotificationCount = action.payload.totalCount;
      state.listLoading = false;
      state.totalCount = totalCount;
    },

    updateNotifications: (state, action) => {
      state.actionsLoading = false;
      const { entity } = action.payload;
      state.notificationEntities = [entity, ...state.notificationEntities.filter((notification) => notification.id != entity.id)];
    },
    
    notificationSet: (state, action) => {
      const { data } = action.payload;
    },
    
    // Setting Date Range of State to get stats on their relevant routes
    dateRangeSet:(state, action)=>{
     state.statsDateRange = action.payload
    },

    setBackgorundJobs: (state, action) => {
      const { data } = action.payload;
      state.jobEntities = [data, ...state.jobEntities];
    },

    fetchJobNotificationList: (state, action) => {
      const { entities } = action.payload;
      state.jobEntities = entities;
      state.listLoading= false;
    },
  },
});
